import { delay, filter, from, map, merge } from "rxjs"

import {
  type EquityPosition,
  type PositionResult,
  SUCCESS_POSITION_RESULT,
  UpdateType,
} from "@/generated/TradingGateway"

import { confirmClosePosition$ } from "../../orders/closePositionSignal"
import { mockEvents, mockPositions } from "../mockData/positionServiceData"
import { IPositionService } from "../PositionService"

// Persists across getPositions() re-subscriptions (e.g. remount) so a closed
// position doesn't reappear in the replayed StateOfTheWorld events.
const closedSymbols = new Set<string>()

const closeEvents$ = confirmClosePosition$.pipe(
  map((symbol) => mockPositions.find((position) => position.symbol === symbol)),
  filter((position): position is EquityPosition => position !== undefined),
  map((position): PositionResult => {
    closedSymbols.add(position.symbol)
    return {
      type: SUCCESS_POSITION_RESULT,
      payload: { updateType: UpdateType.Deleted, payload: position },
    }
  }),
)

export const PositionService: IPositionService = {
  getPositions: () =>
    merge(
      from(mockEvents).pipe(
        filter(
          (event) =>
            event.type !== SUCCESS_POSITION_RESULT ||
            !closedSymbols.has(event.payload.payload.symbol),
        ),
        delay(200),
      ),
      closeEvents$,
    ),
}
